import SectionHero from '@/components/SectionHero';
import DefaultSolutionTemplate from '@/components/templates/Solution';
import { sdk } from '@/lib/graphcms';

export default function Portals({ solution, preview }) {
  return (
    <DefaultSolutionTemplate page={solution} preview={preview}>
      <SectionHero
        title="Empower customers and employees"
        description="Give customers the information they seek, and employees the information they need, all with using fewer resources to maintain a better service. It’s a win-win."
      />
    </DefaultSolutionTemplate>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { solution } = await sdk({ preview }).useCasePage({
    slug: 'portals',
  });

  if (!solution) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      preview,
      solution,
    },
    revalidate: 3600,
  };
};
